import { useCookies } from "vue3-cookies"

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */

const { cookies } = useCookies()
export const isUserLoggedIn = () => {
  return !!(localStorage.getItem('userData') && cookies.get('jwt') && localStorage.getItem('userAbilities'))
}
